import { OwlDateTimeIntl } from 'ng-pick-datetime';
import { Injectable } from "@angular/core";

@Injectable()
export class SetPickerLabels extends OwlDateTimeIntl {
    public setBtnLabel = 'Ange';
    public cancelBtnLabel = 'Avbryt';
};